'use client'

import { type AbstractIntlMessages, NextIntlClientProvider } from 'next-intl'
import { type JSX, type ReactNode } from 'react'

interface Props {
  messages: AbstractIntlMessages
  locale: string
  children: ReactNode
  now: Date
  timeZone: string
}

/**
 *  As of usage from next-intl v4, no defaultTranslationValues are supported anymore. This implementation has been
 *  covered now for t.rich transformation by the function useRichTranslations.
 *
 * @param messages
 * @param locale
 * @param children
 * @param now
 * @param timeZone
 * @constructor
 */
const NextIntlProvider = ({ messages, locale, children, now, timeZone }: Props): JSX.Element => {
  return (
    <NextIntlClientProvider locale={locale} messages={messages} now={now} timeZone={timeZone}>
      {children}
    </NextIntlClientProvider>
  )
}

export default NextIntlProvider
